import { latLngToCell, cellToLatLng } from "./fib-grid";
import { kdTree } from "kd-tree-javascript";

function distance(a, b) {
  var lat1 = a.lat,
    lon1 = a.lng,
    lat2 = b.lat,
    lon2 = b.lng;
  var rad = Math.PI / 180;

  var dLat = (lat2 - lat1) * rad;
  var dLon = (lon2 - lon1) * rad;
  var lat1New = lat1 * rad;
  var lat2New = lat2 * rad;

  var x = Math.sin(dLat / 2);
  var y = Math.sin(dLon / 2);

  var aNew = x * x + y * y * Math.cos(lat1New) * Math.cos(lat2New);
  return Math.atan2(Math.sqrt(aNew), Math.sqrt(1 - aNew));
}

export function getKDTree(points, res) {
  const seen = new Set();
  const uniquePs = [];
  for (const p of points) {
    const id = latLngToCell(p.lat, p.lng, res);
    if (!seen.has(id)) {
      seen.add(id);
      const latlng = cellToLatLng(id);
      uniquePs.push({ id, lat: latlng[0], lng: latlng[1] });
    }
  }
  return new kdTree(uniquePs, distance, ["lat", "lng"]);
}
